import { jsx } from 'react/jsx-runtime';
import { inNextServer } from '@fabric-app/compat';
import UpgradePromptModal from '../../pricing/components/UpgradePromptModal.js';

const LimitSpacesModal = ({ listAmount, onClose }) => {
  if (inNextServer()) return null;
  return /* @__PURE__ */ jsx(UpgradePromptModal, {
    title: "Upgrade for unlimited spaces",
    limitBadge: `${listAmount}/10 free spaces used`,
    onClose
  });
};

export { LimitSpacesModal as default };
//# sourceMappingURL=LimitSpacesModal.js.map
